/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import { baseUrlApi } from './base';

export const getUserParametrage = () => `${baseUrlApi}/parametres-user`;
export const getDefaultSignataire = () =>
  `${baseUrlApi}/individus/default-signataire`;
export const getSignataires = () => `${baseUrlApi}/individus/signataires`;
